import { render, staticRenderFns } from "./question-tip.vue?vue&type=template&id=4fc82a91&scoped=true&"
import script from "./question-tip.vue?vue&type=script&lang=js&"
export * from "./question-tip.vue?vue&type=script&lang=js&"
import style0 from "./question-tip.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./question-tip.vue?vue&type=style&index=1&id=4fc82a91&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc82a91",
  null
  
)

export default component.exports